module.exports = __webpack_public_path__ + "img/corner-joint-left-external.0c691e58.svg";